export const LOCALE_KEYS = {
  fr: 'fr',
  en: 'en',
  it: 'it',
};

export const DEFAULT_NAMESPACE = 'translation'; // default value for i18next namespace
